import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { fetchMe } from "../lib/api";

// Kundli / Predictions / Ask-AI are perks for customers who bought a report.
export default function PaidRoute({ children }) {
  const [me, setMe] = useState(undefined);
  useEffect(() => { fetchMe().then(setMe); }, []);
  if (me === undefined) {
    return (
      <div className="min-h-[50vh] flex items-center justify-center" data-testid="paid-route-loading">
        <Loader2 className="w-6 h-6 animate-spin text-[#1E1B7A]" />
      </div>
    );
  }
  if (!me?.has_paid) return <Navigate to="/reports" replace />;
  return children;
}
